/**
 * The "remember this device for 14 days" grant. It is a signed token from the
 * API (scope: trusted-device) that, when sent back on the next login, lets that
 * login skip the 2FA code. Stored in localStorage alongside the auth token -
 * losing it (private window, cleared storage) simply means the next login asks
 * for a code, so every read is guarded.
 */
const TRUSTED_DEVICE_KEY = "atiraspace_trusted_device";

export const getTrustedDeviceToken = (): string | null => {
  try {
    return localStorage.getItem(TRUSTED_DEVICE_KEY);
  } catch {
    return null;
  }
};

export const setTrustedDeviceToken = (token: string): void => {
  try {
    localStorage.setItem(TRUSTED_DEVICE_KEY, token);
  } catch {}
};

export const clearTrustedDeviceToken = (): void => {
  try {
    localStorage.removeItem(TRUSTED_DEVICE_KEY);
  } catch {}
};
